export const CS = {
  preparing_zip: "Příprava zip…",
  compressing: "Komprimace…",
  info_icon: "Jakmile je označeno jako dokončené, nemohou se připojit ani být přidáni další členové a všechny chatovací skupiny budou deaktivovány. Upozorňujeme, že projekt spolu se všemi chatovacími skupinami a daty zůstane přístupný v deaktivovaném stavu.",
  mark_is_done: "Jste si jisti, že chcete označit projekt jako dokončený? Jakmile je označen, nemohou se připojit ani být přidáni další členové a všechny chatovací skupiny budou deaktivovány. Upozorňujeme, že projekt spolu se všemi chatovacími skupinami a daty zůstane přístupný v deaktivovaném stavu.",
  mark_not_done: "Jste si jisti, že chcete projekt znovu otevřít? Jakmile je označen jako otevřený, mohou se připojit nebo být přidáni další členové a všechny chatovací skupiny budou znovu aktivovány.",
  mark_as_completed: "Označit projekt jako dokončený",
  room_completed: "Projekt dokončen",
  room_members: "Členové projektu",
  deactivated_rooms: "Deaktivované projekty",
  deactivated_chats: "Deaktivované chaty",
  completed_rooms: "Dokončené projekty",
  request_to_join_a_room: 'Žádost o připojení k projektu',
  wants_to_rejoin_room: 'Username se chce znovu připojit k projektu Roomname.',
  invited_you_to_join_room: 'Username vás pozval k připojení k projektu Roomname.',
  restart: "Restartovat",
  update_text: "Je k dispozici nová aktualizace. Klikněte na restartovat pro instalaci aktualizace.",
  update_availble: "Aktualizace k dispozici",
  Loading: "Načítání...",
  logout: "Odhlásit se",
  back: 'Zpět',
  company_list: "Seznam firem",
  followers: "Sledující",
  followings: "Sledovaní",
  article: "Článek",
  companies: "Firmy",
  one_to_one_chat: " Chat jeden na jeden",
  profile: "Profil",
  company: "Firma",
  company_selection: "Výběr firmy",
  home: "Domů",
  contact: "Kontakt ",
  add_company: "Přidat firmu ",
  add_project: "Přidat projekt ",
  capacities: "Kapacity ",
  work_area: "Pracovní oblast",
  company_services: "Služby firmy",
  website: "Webová stránka",
  search_contacts: "Hledat kontakty",
  add_or_join_a_company: "Přidat nebo se připojit k firmě",
  follow: "Sledovat",
  following: "Sledování",
  like: "Líbí se",
  company_contacts: "Kontakt firmy",
  leave_the_company: "Opustit firmu",
  news: "Novinky",
  earlier: "Dříve",
  action: "Akce",
  another_action: "Jiná akce",
  something_else: "Něco jiného",
  search: "Hledat",
  search_rooms: "Hledat projekty",
  search_articles: "Hledat články",
  contacts: "Kontakty",
  suggestions: "Návrhy",
  project_list: "Seznam projektů",
  search_results: "Výsledky hledání",
  add_or_join_project: "Přidat nebo se připojit k projektu",
  details: "Detaily",
  your_position_within_company:
    "Prosím vyberte svou pozici ve firmě.",
  close_modal: "Zavřít",
  map: "Mapa",
  or: "Nebo",
  name: "Jméno*",
  street: "Ulice*",
  house_number: "Číslo domu",
  postal_code: "PSČ",
  city: "Město*",
  opened_by: "Otevřeno:",
  project_No: "Číslo projektu: ",
  building_type: "Typ budovy*",
  building_types: "Typ budovy",
  add_join: "Přidat/Připojit se",
  mandatory_fiels: "*povinná pole",
  invalid_fiels: "Toto pole je povinné",
  add_or_join_company: "Přidat nebo se připojit k firmě",
  name_of_the_company: "Název firmy",
  edit_company_details: "Upravit údaje firmy",
  branch_of_the_building_industry: "Obor stavebního průmyslu",
  corporate_form: "Právní forma",
  position_within_company: "Pozice ve firmě",
  request_confirmation: "Čekající žádosti o projekty",
  company_e_mail: "E-mail firmy",
  type_of_filter: "Zadejte pro filtrování...",
  setting: "Nastavení",
  dashboard: "Nástěnka",
  settings: "Nastavení",
  views: "Zobrazení",
  times_seen: "krát zobrazeno",
  see_more: "...více",
  see_less: "...méně",
  in_search: "ve vyhledávání",
  reset_password: "Obnovit heslo",
  submit: "Odeslat",
  password: "Heslo",
  email: "E-mail",
  confirm_password: "Potvrdit heslo",
  reset_email: "Obnovit e-mail",
  update: "Aktualizovat",
  new_email: "Nový e-mail",
  kjuup_message: "Kjuup Zpráva",
  delete_profile: "Smazat profil?",
  my_position: "Moje pozice:",
  add: "přidat",
  owner_company_admin: "Správce firmy :",
  owner_company_admin_new: "Správce firmy",
  mutual_contact: "společný kontakt",
  mutual_contacts: "společné kontakty",
  co_owner: "Spolumajitel",
  managing_director: "Generální ředitel",
  associate: "Společník",
  secretary: "Tajemník",
  employee: "Zaměstnanec",
  project_manage: "Vedoucí projektu",
  auto_chat_translation: "Automatický překlad chatu",
  translate_room_group_names: "Překládat názvy projektů a skupin",
  translate_room_group_names_info: "Pokud je zapnuto, názvy projektů a chatovacích skupin se automaticky překládají do jazyka rozhraní.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Když je aktivováno, při otevření aplikace se místo Zpráv standardně otevře karta E-Mail.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Jazyk",
  english: "Angličtina",
  german: "Němčina",
  french: "Francouzština",
  italian: "Italština",
  change_language: "Změnit jazyk",
  my_companies: "Moje firmy",
  employees: "Zaměstnanci",
  invite_with_a: "Pozvat do Kjuup",
  add_member: "Přidat člena",
  add_user: "Přidat uživatele",
  send_location: "Odeslat polohu",
  assign_admin_rights: "Upravit právo správce",
  deactivate_company: "Deaktivovat firmu",
  remove_employees: "Odebrat zaměstnance",
  remove_members: "Odebrat členy",
  no_user_found: "Uživatel nenalezen!",
  approve: "Schválit!",
  deselect_all: "Zrušit výběr všeho",
  select_all: "Vybrat vše",
  translation_on_building_projects: "Překlad v projektech",
  reported_capacities: "Nahlášené služby",
  up_to_50m_exact: "Až 50m přesně",
  company_details_service: "Služby firmy",
  company_contact: "Kontakt firmy",
  invite_with_link: "Pozvat do Kjuup",
  share_link: "Sdílet odkaz",
  share_company_link: "Sdílet odkaz",
  qr_code: "QR kód",
  copy_link: "Kopírovat odkaz",
  cancel_link: "Zrušit odkaz",
  who_has_confirmed_services: "Kdo potvrdil vaše služby?",
  projectss: "Projekty",
  add_services: "Přidat služby",
  services: "Služby",
  save_text: "Uložit",
  share_on: "Sdílet na:",
  articlen: "Článek",
  invite_user_to_confirm_service:
    "Pozvěte uživatele k potvrzení služeb firmě.",
  link_copied: "Odkaz zkopírován!",
  email_copied: "E-mail zkopírován!",
  personal_article: "Osobní článek",
  company_article: "Firemní článek",
  characters_remaining: "Zbývající znaky",
  optional_information: "Volitelné informace",
  project: "Projekt",
  projects: "Projekty...",
  abort: "Zrušit",
  preview: "Náhled",
  post: "Zveřejnit",
  of: "z",
  remove: "Odebrat",
  free_capacity: "Portál práce",
  current_status_overview: "Přehled aktuálního stavu",
  report_capacities: "Nahlásit služby",
  report_text: "Nahlásit",
  search_capacities: "Najít dodavatele",
  add_project_user: "Přidat uživatele projektu",
  media: "Média",
  links: "Odkazy",
  docs: "Dokumenty",
  featured_products: "Doporučené produkty...",
  title: "Nadpis",
  text: "Text",
  feed_details: "Detaily kanálu",
  add_employee: "Přidat zaměstnance",
  latest: "Nejnovější",
  my_projects: "Moje projekty",
  cancel: "Zrušit",
  continue: "Pokračovat",
  role_in_the_building_industry: "Role ve stavebním průmyslu",
  als: "jako",
  join: "připojit se",
  find: "Najít",
  request_to_join_a_company: "Žádost o připojení k firmě",
  wants_to_join_the_company: "chce se připojit k firmě",
  filter_by: "Filtrovat podle",
  ok: "Ok",
  close: "Zavřít",
  weekly_statistics: "Týdenní statistiky",
  is_following_you: "vás sleduje.",
  as: "jako",
  has_joined_the: "se připojil k firmě",
  has_looked_at_your_profile: "se podíval na váš profil.",
  time: "Čas",
  in_searches_in_past_week: "ve vyhledáváních v minulém týdnu.",
  has_liked_your_article: "se mu líbil váš článek.",
  has_published_a_new_article: "zveřejnil nový článek.",
  you: "Vy",
  all_views: "Všechna zobrazení",
  all_profile_views: "Všechna zobrazení profilu",
  mutual_company: "společná firma",
  artical_text: "Napsat článek...",
  you_have_appeared: "Objevili jste se",
  your_request_at_the_company: "Vaše žádost ve firmě",
  times_you_have_appeared_in_searches: "krát jste se objevili ve vyhledáváních",
  appear_more_often_in_searches: "Objevovat se častěji ve vyhledáváních",
  you_have_been_found: "Byli jste nalezeni",
  improve_profile: "Zlepšit profil",
  choose_existing_contact_for_single_chat:
    "Vyberte existující kontakt pro individuální chat:",
  in_order_to_add_new_contacts:
    "Pro přidání nových kontaktů prosím vyhledejte nové kontakty na stránce profilu.",
  times_in_searches_in_the_last_week:
    "krát ve vyhledáváních v minulém týdnu. Aktualizujte svůj profil a přidejte další detaily, abyste byli snadněji nalezeni.",
  has_been_confirmed: "bylo potvrzeno.",
  have_joined_the: "se připojili k  ",
  building_project: " stavebnímu projektu.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Vyberte firmu, kterou budete zastupovat. Toto bude zobrazeno ostatním účastníkům.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Vyberte firmu, kterou budete zastupovat. Toto bude zobrazeno ostatním účastníkům.",
  select_internal_section: "Prosím vyberte interní sekci",
  select_profile_image: "Vybrat obrázek profilu",
  share_user: "Sdílet uživatele",
  contact_sender_message:
    "Sdílejte tento odkaz pro pozvání nečlena Kjuup do Kjuup. Tento odkaz může být použit více lidmi pro registraci.",
  project_sender_message:
    "Sdílejte tento odkaz pro pozvání nečlena Kjuup do projektu název projektu. Tento odkaz může být použit více lidmi pro registraci a připojení k projektu název projektu v Kjuup.",
  company_sender_message:
    "Sdílejte tento odkaz pro pozvání nečlena Kjuup do firmy název firmy. Tento odkaz může být použit více lidmi pro registraci a připojení k firmě v Kjuup.",
  contact_receivers_message:
    "Odkaz na pozvánku pro připojení k Kjuup. Prosím klikněte na odkaz pro registraci do kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "V případě, že instalujete Kjuup přes Apple App Store, musíte kliknout na tento odkaz po úspěšném stažení, abyste se mohli zaregistrovat.",
  project_receivers_message:
    "Odkaz na pozvánku pro připojení k projektu název projektu v Kjuup. Prosím klikněte na odkaz pro registraci do Kjuup a připojení k projektu název projektu.",
  company_receivers_message:
    "Odkaz na pozvánku do firmy název firmy v Kjuup. Prosím klikněte na odkaz pro registraci do Kjuup a připojení k firmě název firmy.",
  sign_in: "Přihlásit se",
  enter_your_email_add: "Zadejte svou e-mailovou adresu",
  forgot_password: "Zapomněli jste heslo?",
  dont_have_account: "Nemáte účet?",
  register: "Registrovat",
  get_app: "Získat aplikaci",
  registration: "Registrace",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architekt",
  prof: "Prof.",
  first_name: "Jméno",
  last_name: "Příjmení",
  have_an_account: "Máte účet?",
  when_register_you_agree: "Při registraci souhlasíte s našimi",
  term_of_use: "podmínkami použití",
  to: ".",
  in_our: "V našich",
  data_policy: "zásadách ochrany údajů",
  they_find_out: "se dozvíte,",
  we_provide_store_data: "jak shromažďujeme, zpracováváme a ukládáme informace.",
  leaving_company_text:
    "Opravdu chcete opustit firmu? Při opuštění firmy také opustíte všechny související projekty a chatovací skupiny. Můžete se znovu připojit k těmto projektům s jinou firmou kdykoli.",
  delete_profile_text:
    "Opravdu chcete smazat svůj profil? Když smažete svůj profil, všechny připojení k firmám, projektům a chatům budou odstraněna. Můžete vytvořit nový profil kdykoli.",
  confirm: "Potvrdit",
  reject: "Odmítnout",
  requet_to_leave: "Žádost o opuštění",
  choose: "Vybrat",
  your_add_member: "Přidat člena",
  if_you: "v případě, že",
  can_not_find: "nemůžete najít svůj kontakt zde.",
  please_wait: "Prosím čekejte..",
  imprint_gtc: "Tiráž/Podmínky použití",
  register_confirm_popup: "Před přihlášením ověřte svou e-mailovou adresu Kjuup. Odeslali jsme potvrzovací odkaz. Pokud ho nevidíte, zkontrolujte i složku spam.",
  PENDING_GROUP_USER:
    "obdrží zprávy pouze poté, co bude pozvánka do projektu potvrzena. Další zpráva se objeví, jakmile bude pozvánka do projektu potvrzena.",
  PENDING: "Čeká se na potvrzení pozvánky do projektu",
  denied_group_chat: " odmítl pozvánku do projektu a opustil tuto skupinu.",
  // joined_group_chat: " se připojil k místnosti a této skupině.",
  joined_group_chat: " se připojil k této skupině",
  you_joined_group_chat: "Připojili jste se k této skupině.",
  Others: "Ostatní",
  LEFT_GROUP: "opustil tuto chatovací skupinu.",
  YOU_LEFT_GROUP: "opustili tuto chatovací skupinu.",
  days: "dní",
  day: "den",
  hour: "hodina",
  hide_project: "Skrýt projekt",
  hide_project_popup_text:
    "Pokud skryjete projekty, nemohou být nalezeny v Kjuup. Pouze členové projektu mohou pozvat nové uživatele do projektu.",
  branch: "Obor",
  photo_video_media_lib: "Knihovna médií - Fotografie a video",
  document: "Dokument",
  location_meeting: "Poloha / Schůzka",
  all_member_of_project: "Všichni členové projektu",
  pending_request: "Čekající žádosti o projekty",
  no_pending_request: "Nebyly nalezeny žádné čekající žádosti!",
  news_feed: "Novinky",
  user_info: "Informace o skupině",
  leave_project: "Opustit projekt",
  media_link_docs: "Soubory",
  search_chat: "Hledat v chatu",
  export_chat_group: "Exportovat data chatovací skupiny z minulého měsíce",
  request_complete_chat_history: "Požádat o kompletní historii chatu",
  leave_chat_group: "Opustit chatovací skupinu",
  add_user_project: "Přidat uživatele",
  me: "Já",
  max_open_one_to_one:
    "V současnosti lze otevřít max. 2 chaty jeden na jeden paralelně v dolní a horní sekci. Celkem je možné max. 4 chaty jeden na jeden.",
  are_you_sure_you_want_leave_chat:
    "Jste si jisti, že chcete opustit tuto chatovací skupinu?",
  create_group: "Vytvořit skupinu",
  adding_members: "Přidávání členů...",
  creating_the_chat: "Vytváření chatu...",
  finishing_setup: "Dokončování...",
  group_name: "Název skupiny",
  by: "Od:",
  mandetory: "*povinné",
  delteed: "smazal(a) svůj profil a opustil(a) skupinový chat.",
  deleted_direct: "smazal(a) svůj profil a opustil(a) chat.",
  unhidden_message:
    "Pokud zobrazíte projekty, mohou být nalezeny všemi členy Kjuup.",
  account_deleted: "Účet byl smazán.",
  refuse_company: "Jste si jisti, že chcete odmítnout pozvánku firmy?",
  follow_additional: "Sledovat další uživatele",
  f_add:
    "Sledujte další uživatele Kjuup, aby byli dostupní pro přímé zprávy.",
  c_inv: "Pozvánka(y) firmy",
  invited_o_Company: "Byli jste pozváni připojit se k firmě",
  refuse_companyX: "Jste si jisti, že chcete odmítnout žádost firmy?",
  a_Da: "Účet deaktivován.",
  has_deactivated: "deaktivoval(a) svůj profil.",
  reactive: "znovu aktivoval(a) svůj profil.",
  juup_note: "*Registrace s uživatelským jménem dostupná pouze pro členy Kjuup+",
  username: "Uživatelské jméno*",
  email_username: "E-mail/Uživatelské jméno*",
  sPinText:
    "Prosím zadejte 6místný bezpečnostní PIN. Tento PIN bude potřebný v případě, že zapomenete své heslo a je povinný pro potvrzení vašeho účtu.",
  DeleteKjuupPlusText:
    "Opravdu chcete smazat svůj profil? Když smažete svůj profil, všechny připojení k firmám, projektům a chatům budou odstraněna.\n\nDo 48 hodin po smazání účtu můžete znovu aktivovat svůj účet přihlášením s uživatelským jménem, heslem a PIN.",
  reactive_text:
    "Váš účet byl smazán. Prosím klikněte na Znovu aktivovat pro znovuaktivaci vašeho účtu.",
  rac: "Znovu aktivovat",
  ac_ss: "Účet byl úspěšně znovu aktivován.",
  not_valid_pin: "PIN neplatný",
  only_for_kjuup:
    "*Obnovení hesla přes uživatelské jméno a PIN dostupné pouze pro členy Kjuup+.",
  resetPIN: "Obnovit PIN",
  enter_current_pin: "Prosím zadejte svůj aktuální PIN",
  enter_new: "Zadejte nový PIN",
  pin_to_confirm: "Prosím zadejte PIN pro potvrzení.",
  change_username: "Obnovit uživatelské jméno",
  pp_not_match: "Heslo a potvrzení hesla se neshodují",
  reactive_itself: "Znovu jste aktivovali svůj profil.",
  has_deactivated_itself: "Deaktivovali jste svůj profil.",
  more_than_two:
    "V současnosti lze přímé zprávy posílat pouze 2 uživatelům paralelně.",
  Chats: "Přímé zprávy",
  only_in_mobileL:
    "Nativní videa lze v současnosti nahrávat a zveřejňovat pouze přes mobilní aplikaci. Prosím použijte odkazy na videa z Youtube a Vimeo.",
  register_pin_text:
    "Prosím vyberte svůj osobní 6místný PIN. Tento PIN bude potřebný pro povolení funkcí obnovení účtu.",
  internal_project: "Interní",
  external_projects: "Externí",
  in_deacticted: "Interní sekce je deaktivována.",
  create_article: "Vytvořit článek",
  new_article_selection: "Vytvořit článek pro externí novinky",
  new_article_selection_internal: "Vytvořit interní článek",
  active_trans_title: "Zapnout automatický překlad?",
  active_trans: "Po zapnutí budou všechny příchozí zprávy chatu přeloženy do vybraného jazyka aplikace.",
  disable_trans: "Opravdu chcete deaktivovat automatický překlad?",
  allow_access_chat: "Zobrazit kompletní historii chatu",
  toggle_chat_history_on:
    "Opravdu chcete, aby uživatel viděl kompletní historii chatu?",
  toggle_chat_history_off:
    "Opravdu chcete, aby uživatel viděl pouze historii chatu od okamžiku připojení k chatu?",
  check_selected_settings:
    "Prosím zkontrolujte nastavení historie chatu pro všechny vybrané uživatele!",
  chat_from_start_have:
    "Připojili jste se k této skupině. Historie chatu byla sdílena.",
  chat_from_start_has:
    "se připojil k této skupině. Historie chatu byla sdílena.",
  Address: "Adresa",
  read_by: "Přečteno",
  deliver_to: "Doručeno",
  remaining: "zbývá",
  message_info: "Informace o zprávě",
  request_to_join_only: "Žádost o připojení",
  unfollow: "Přestat sledovat",
  company_username: "Uživatelské jméno",
  month: [
    "Led",
    "Úno",
    "Bře",
    "Dub",
    "Kvě",
    "Čer",
    "Čvc",
    "Srp",
    "Zář",
    "Říj",
    "Lis",
    "Pro",
  ],
  remove_my_admin_right: "Odebrat má práva správce",
  makeEmp: "Opravdu chcete odebrat práva správce firmy uživateli?",
  remove_my_self:
    "Opravdu chcete odebrat práva správce firmy ze svého účtu?",
  makeAdmin: "Opravdu chcete dát uživateli práva správce firmy?",
  remove_member: "Odebrat člena",
  remove_following_confirm: "Opravdu chcete odebrat {name} ze seznamu sledovaných?",
  remove_follower_confirm: "Opravdu chcete odebrat {name} ze svých sledujících? Pokud ho/jí odeberete, nebude o tom informován/a.",
  do_you_really_want_to_remove:
    "Opravdu chcete odebrat uživatelské jméno z firmy?",
  invite_all: "Pozvat všechny členy firmy",
  invite_all_members: "Pozvat všechny členy",
  mems: "Všichni ostatní členové",
  dep_loc: "Oddělení/Poloha/Tým",
  depAdmin: "Správce oddělení",
  add_remove_admin: "Přidat/Odebrat pozici správce firmy",
  add_remove_dep_admin: "Přidat/Odebrat pozici správce oddělení",
  remove_employees_dept: "Odebrat zaměstnance z",
  want_to_join_dep:
    "Uživatelské jméno chce se připojit k Oddělení/Poloha/Tým depname firmy companyname.",
  you_invited:
    "Byli jste pozváni připojit se k Oddělení/Poloha/Tým depname firmy companyname.",
  dep_remove:
    "Opravdu chcete odebrat práva správce oddělení nebo polohy uživateli?",
  add_dep:
    "Opravdu chcete dát uživateli práva správce pro oddělení nebo polohu?",
  my_self_dep_remove:
    "Opravdu chcete odebrat práva správce oddělení ze svého účtu?",
  member: "Člen",
  admin: "Správce",
  remove_project_admin:
    "Opravdu chcete odebrat člena z projektu?",
  remove_my_self_project: "Opravdu chcete odebrat práva správce?",
  remove_member_admin_right:
    "Opravdu chcete odebrat práva správce uživateli?",
  add_member_admin_right: "Opravdu chcete přidat práva správce uživateli?",
  add_remove_Poss: "Přidat/Odebrat pozici správce",
  forward: "Přeposlat",
  edit: "Upravit",
  only_kjuup_plus_can: "Pouze firmy Kjuup+ mohou zveřejňovat články.",
  add_images: "Přidat obrázek(y)",
  request_confirmation: 'Čekající pozvánky do projektů',
  Activity: "Aktivita",
  latest_messages: "Nejnovější zprávy",
  hours: "hodin",
  minute: "minut",
  seconds: "sekund",
  days: "dní",
  yesterday: "včera",
  last_week: "minulý týden",
  next_week: "příští týden",
  Last_month: "minulý měsíc",
  All: "Vše",
  register_plus: "Registrace Plus",
  select_files: "Vybrat soubory",
  monthsFullName: [
    "Leden",
    "Únor",
    "Březen",
    "Duben",
    "Květen",
    "Červen",
    "Červenec",
    "Srpen",
    "Září",
    "Říjen",
    "Listopad",
    "Prosinec",
  ],
  company_deploc_receivers_message:
    "Odkaz na pozvánku do oddělení firmy název firmy v Kjuup. Prosím klikněte na odkaz pro registraci do Kjuup a připojení k firmě název firmy.",
  no_news: "Žádné novinky k dispozici",
  reminder: "Připomínka",
  np_reminder: "Žádné úkoly",
  move_to_reminder: "Přesunout do úkolu",
  remove_reminder: "Opravdu chcete odebrat tuto zprávu ze seznamu vašich úkolů?",
  remove_all_reminder: "Odebrat všechny úkoly",
  remove_all_confirm: "Opravdu chcete odebrat všechny zprávy ze seznamu vašich úkolů?",
  remove_from_reminder: "Odebrat z připomínky",
  prevent_email: "E-mail nemůže být použit jako uživatelské jméno.",
  allow_noti: "Prosím povolte oznámení.",
  join_cap: "Připojit se",
  pass_minimum:
    "**Heslo vyžaduje 12 znaků včetně malého písmene, velkého písmene, číslice a speciálního znaku.",
  pass_error: "Prosím zkontrolujte požadavky na heslo",
  people_that_like_article: "Lidé, kterým se článek líbí.",
  people_who_like_article: "Lidé, kterým se váš článek líbí.",
  message_delete: "Tato zpráva byla smazána.",
  message_edited: "upraveno",
  edit_message: "Upravit zprávu",
  edit_window_expired: "Zprávy lze upravit pouze do 10 minut po odeslání.",
  message_edit_save: "Uložit",
  copy: "Kopírovat",
  bookmark: "Záložka",
  add_reaction: "Přidat reakci",
  delete_message: "Smazat zprávu",
  more_options: "Další možnosti",
  info: "Info",
  link_invite: "Pozvat přes odkaz",
  ll_nkk: "Pozvat do Kjuup",
  selected: "Vybráno",
  is_active: "Aktivní",
  inactive: "Neaktivní",
  last_online: "naposledy online {{when}}",
  remove_user_l: "Odebrat",
  link_expire: "Každý vygenerovaný odkaz bude platný po dobu 72 hodin.",
  company_language: "Jazyk firmy",
  company_language_info:
    "Výběr jazyka bude použit pro všechna e-mailová potvrzení týkající se firmy.",
  s_image: "obrázek",
  m_image: "obrázky",
  removeMsg: "Klepněte pro odebrání",
  block: 'Blokovat',
  unblock: 'Odblokovat',
  blocks: 'Jste si jisti, že chcete zablokovat tohoto uživatele?',
  unblocks: 'Jste si jisti, že chcete odblokovat tohoto uživatele?',
  bolcked_click_un_block:
    'Zablokovali jste tento kontakt. Klikněte zde pro odebrání blokování.',
  you_have_unblocked: 'Odblokovali jste tento kontakt.',
  you_have_blocked: 'Zablokovali jste tento kontakt.',
  unblock_to_send: 'Odblokujte uživatele pro odeslání zprávy.',
  pilot_text: "Specializovaná AI pro stavební témata",
  startup_screen_label: "Úvodní obrazovka",
  startup_screen_info: "Vyberte, která obrazovka se otevře při spuštění Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Zprávy",
  startup_screen_saved: "Úvodní obrazovka aktualizována",
email_on: "E-mailová oznámení chatů",
  email_on_grp: "E-mailové oznámení",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivovat nebo deaktivovat e-mailová oznámení pro tento projekt. Tato možnost je dostupná pouze, když jsou \"E-mailová oznámení chatů\" povolena přes osobní nastavení.",
  todo_notification_info: "Budete upozorněni pokaždé, když vám bude přidělen nový úkol.",
  info_val: "Dostanete e-mail, pokud si novou zprávu v chatu nepřečtete během krátké doby. Můžete to vypnout pro konkrétní projekty nebo chaty v jejich nastavení nebo v informacích chatovací skupiny.",
  email_groups: "Aktivovat nebo deaktivovat e-mailová oznámení pro tento chat. Tato možnost je dostupná pouze, když jsou \"E-mailová oznámení chatů\" povolena přes osobní a nastavení projektu.",
  add_update_email: "Přidat/Aktualizovat e-mail",
  text_to_verifiy: "Možnost \"E-mailová oznámení chatů\" může být povolena pouze, pokud máte ověřenou e-mailovou adresu v souboru.",
  stored_email: "Uložený e-mail: ",
  verify_email: "Čeká se na potvrzení!",
  join_call:"Připojit se",
  call_is_started:"Hovor byl zahájen",
  start_chat:"Spustit přímý chat?",
  project_rooms:"Projekty",
  download_selected:"Stáhnout",
  add_employee_confirm: 'Jste si jisti, že chcete přidat tohoto uživatele do firmy?',
  invalid_deeplink: "Neplatná URL hlubokého odkazu. Chybí povinné parametry.",
  deeplink_error: "Nelze zpracovat hluboký odkaz. Prosím zkuste to znovu později.",
  // Reply functionality translations
  reply: "Odpovědět",
  reply_enter: "Zadejte odpověď...",
  reply_sent_successfully: "Odpověď úspěšně odeslána",
  reply_failed: "Odeslání odpovědi selhalo",
  reply_failed_generic: "Odeslání odpovědi selhalo. Prosím zkuste to znovu.",
  replying_to_message: "Odpovídání na zprávu",
  cancel_reply: "Zrušit odpověď",
  voice_message: "Hlasová zpráva",
  send: "Odeslat",
  cancel: "Zrušit",
  type_your_reply: "Napište svou odpověď...",
  
  // Auto-suggestion translations
  suggested_replies: "Navržené odpovědi",
  suggestions_error: "Načtení návrhů selhalo",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Chvíli. Váš text je připravován individuálně pro vás.",
  loading_chat_message: "Načítání chatu...",
  
  // Manual ToDo translations
  extracting_message: "Extrahování zprávy...",
  create_todo: "Vytvořit úkol",
  create_todo_confirmation: "Chcete vytvořit úkol z této zprávy?",
  select_project_required: "Prosím vyberte projekt/skupinu",
  only_assigned_can_change_status: "Pouze přiřazení uživatelé mohou změnit stav",
  todo_summary: "Shrnutí",
  todo_summary_placeholder: "Zadejte shrnutí úkolu...",
  todo_date: "Datum",
  todo_time: "Čas",
  todo_date_hint: "Ponechte prázdné pro použití data/času původní zprávy",
  todo_created_success: "Úkol úspěšně vytvořen",
  todo_creation_failed: "Vytvoření úkolu selhalo",
  create: "Vytvořit",
  
  image: "obrázek",
  images: "obrázky",
  remove_all_images: "Odebrat všechny obrázky",
  remove_image: "Odebrat obrázek",
  remove_document: "Odebrat dokument",
  remove_recording: "Odebrat nahrávku",
  play_recording: "Přehrát nahrávku",
  upload_image: "Nahrát obrázek",
  upload_document: "Nahrát dokument",
  record_audio: "Nahrát audio",
  stop_recording: "Zastavit nahrávání",
  stop_recording_text: "Zastavit nahrávání",
  please_remove_current_attachment: "Prosím odeberte současnou přílohu pro",
  please_upload_image_file: "Prosím nahrajte platný soubor obrázku",
  please_upload_valid_document: "Prosím nahrajte platný soubor dokumentu",
  searching_messages: "Hledání zpráv...",
  loading_more: "Načítání více...",
  loading_more_users: "Načítání více uživatelů...",
  load_more_users: "Načíst více uživatelů",
  no_more_users_to_load: "Žádní další uživatelé k načtení",
  no_messages_found: "Nebyly nalezeny žádné zprávy",
  try_different_keyword: "Zkuste jiné klíčové slovo nebo zkontrolujte pravopis.",
  search_messages: "Hledat zprávy, chatové skupiny, projekty a uživatele...",
  todo: "Úkol",
  np_todo: "Žádné úkoly",
  move_to_todo: "Uložit jako úkol",
  remove_todo: "Opravdu chcete odebrat úkol?",
  remove_all_todo: "Odebrat všechny úkoly",
  remove_all_todo_confirm: "Opravdu chcete odebrat všechny úkoly?",
  add_to_todo: "Přidat k úkolu",
  remove_from_todo: "Odebrat z úkolu",
  confirm: "Potvrdit",
  ok: "Ok",
  read_more: "Číst více",
  show_less: "Zobrazit méně",
  show_more: "Zobrazit více",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  notification_schedule: "Rozvrh oznámení",
  notification_schedule_desc: "Budete dostávat push a e-mailová oznámení pouze v hodinách, které si vyberete. Mimo tyto časy budou pozastavena.",
  learn_more: "Zjistit více",
  allow_notifications: "Povolit oznámení:",
  every_day: "Každý den",
  weekdays: "Pracovní dny (pondělí až pátek)",
  custom: "Vlastní",
  monday: "Pondělí",
  tuesday: "Úterý",
  wednesday: "Středa",
  thursday: "Čtvrtek",
  friday: "Pátek",
  saturday: "Sobota",
  sunday: "Neděle",
  to: "do",
  notification_settings: "Oznámení",
  notification_settings_saved: "Nastavení oznámení úspěšně uloženo",
  notification_settings_error: "Uložení nastavení oznámení selhalo",
  unavailability_note: "Oznámení o nepřítomnosti",
  unavailability_description: "Nastavte oznámení o nepřítomnosti. Pokud je aktivní, oznámení se zobrazuje ostatním ve všech vašich chatech a oznámení jsou pozastavena.",
  unavailability_start_date: "Datum zahájení",
  unavailability_end_date: "Datum ukončení",
  unavailability_message: "Zpráva",
  unavailability_message_hint: "Použijte {endDate} jako zástupný symbol pro datum návratu.",
  unavailability_replacement: "Zástupce",
  unavailability_replacement_placeholder: "Zadejte ID uživatele pro naléhavé požadavky",
  unavailability_replacement_current: "Aktuální zástupce",
  unavailability_replacement_hint: "Pokud je nastaveno, v oznámení o nepřítomnosti se zobrazí odkaz pro kontaktování této osoby v naléhavých záležitostech.",
  unavailability_replacement_none: "Žádný zástupce (volitelné)",
  unavailability_contact_urgent: "V naléhavých případech kontaktujte",
  unavailability_default_message: "V současné době nejsem v kanceláři a nemám přístup ke Kjuup. Od {endDate} budu opět k dispozici a ozvu se vám.",
  unavailability_save: "Uložit",
  unavailability_deactivate: "Deaktivovat",
  unavailability_active_until: "Aktivní do",
  unavailability_saved: "Oznámení o nepřítomnosti uloženo",
  unavailability_save_error: "Nepodařilo se uložit oznámení o nepřítomnosti",
  unavailability_deactivated: "Oznámení o nepřítomnosti deaktivováno",
  unavailability_end_date_required: "Datum ukončení je povinné",
  start_time_before_end_time: "Čas začátku musí být před časem konce",
  loading: "Načítání",
  disabled: "Zakázáno",
  enable: "Povolit",
  disable: "Zakázat",
  forwarded: "Přeposláno",
  message_forwarded: "Zpráva přeposlána!",
  // Schedule Article
  schedule_article_post: "Naplánovat zveřejnění článku",
  date: "Datum",
  time: "Čas",
  scheduled_for_publication: "Naplánováno k zveřejnění",
  article_will_be_published_on: "Článek bude zveřejněn:",
  reset_selection: "Obnovit výběr",
  continue: "Pokračovat",
  cancel: "Zrušit",
  // Member Selection
  error_loading_members: "Chyba při načítání členů",
  please_fill_all_fields: "Prosím vyplňte všechna pole",
  invalid_email: "Neplatná e-mailová adresa",
  member_added_successfully: "Člen úspěšně přidán",
  error_onboarding_user: "Chyba při přidávání uživatele",
  error_creating_chat: "Chyba při vytváření chatu",
  error_creating_group: "Chyba při vytváření skupiny",
  new_group: "Nová skupina",
  please_select_or_enter_group_name: "Prosím vyberte skupinu nebo zadejte název skupiny",
  please_select_or_enter_room_name: "Prosím vyberte projekt nebo zadejte název projektu",
  error_creating_room: "Chyba při vytváření projektu",
  error_opening_chat: "Chyba při otevírání chatu",
  privacy_modal_text: "Vyberte \"Soukromý\" pouze pokud chat neobsahuje relevantní profesionální obsah pro projektového manažera.",
  not_private: "Nesoukromý",
  private: "Soukromý",
  error_loading_groups: "Chyba při načítání skupin",
  automatic_chat_export: "Automatický export chatu",
  automatic_chat_export_info: "Po aktivaci bude historie chatu automaticky odesílána na zadanou e-mailovou adresu každý měsíc.",
  automatic_chat_export_no_email: "Chcete-li povolit automatický export chatu, musíte nejprve přidat e-mailovou adresu. Svou e-mailovou adresu můžete přidat v osobním nastavení.",
  enter_email: "Zadejte e-mail",
  update: "Aktualizovat",
  confirm: "Potvrdit",
  export_to_email: "Export jde na následující e-mail.",
  start_chat_button:"Nová zpráva",
  matching_existing_chats: "Odpovídající existující chaty",
  subject: "Předmět",
  add_subject: "Přidat předmět",
  chat_subject: "Předmět chatu:",
  set_project_room: "Nastavit projekt",
  matching_existing_project_rooms: "Odpovídající existující projekty",
  name_project_room: "Pojmenovat projekt",
  professional_or_private: "Profesionální nebo soukromý",
  professional: "Profesionální",
  privacy_modal_text_updated: "Vyberte \"Soukromý\" pouze pokud chat neobsahuje relevantní profesionální obsah pro projektové manažery. Soukromé chaty nejsou viditelné pro projektové manažery.",
  create_internal_chat: "Externí - nebo interní chat?",
  internal_chat_description: "Pouze zaměstnanci vaší firmy mohou být přidáni do interních chatů.",
  yes: "Ano",
  no: "Ne",
  chat_is_being_created: "Chat se vytváří...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Opravdu chcete zahodit změny tohoto článku?",
  please_enter_article_title: "Prosím nejprve zadejte název článku.",
  please_add_mandatory_fields: "Prosím přidejte všechna povinná pole",
  product_label: "Produkt:",
  no_companies_found: "Nebyly nalezeny žádné firmy",
  visible_to_all_followers: "Viditelné pro všechny členy Kjuup",
  only_visible_to_employees: "Viditelné pouze pro zaměstnance",
  something_went_wrong: "Něco se pokazilo, prosím zkuste to znovu",
  please_select_department: "Prosím vyberte oddělení/polohu",
  schedule: "Naplánovat",
  please_select_future_date_time: "Prosím vyberte budoucí datum a čas pro naplánování článku.",
  please_select_different_date_time: "Prosím vyberte jiné datum nebo čas pro naplánování článku.",
  please_select_later_time: "Prosím vyberte čas později než aktuální čas pro dnešek.",
  unpin_article: "Odepnout článek",
  pin_article: "Připnout článek",
  and: "a",
  others: "ostatní",
  at: "v",
  // Chat mute/unmute translations
  mute: "Ztlumit",
  unmute: "Zrušit ztlumení",
  chat_muted_successfully: "Chat úspěšně ztlumen",
  chat_unmuted_successfully: "Ztlumení chatu úspěšně zrušeno",
  mute_chat_confirm: "Opravdu chcete ztlumit tento chat? Už nebudete dostávat oznámení pro nové zprávy.",
  unmute_chat_confirm: "Opravdu chcete zrušit ztlumení tohoto chatu? Znovu budete dostávat oznámení pro nové zprávy.",
  please_select_group_to_forward: "Prosím vyberte skupinu pro přeposlání zprávy",
  // Company translations
  record_not_found: "Záznam nenalezen!",
  please_select_position: "Prosím vyberte pozici",
  delete_article_confirm: "Jste si jisti, že chcete smazat tento článek?",
  delete_company_service_confirm: "Jste si jisti, že chcete smazat službu firmy?",
  block_translation_confirm: "Opravdu chcete zablokovat automatický překlad v projektech pro všechny členy firmy",
  unblock_translation_confirm: "Opravdu chcete odblokovat automatický překlad v projektech pro všechny členy firmy",
  please_select_file: "Prosím vyberte soubor pro nahrání",
  role_in_building_industry: "Role ve stavebním průmyslu*",
  invalid_email_address: "Neplatná e-mailová adresa",
  please_enter_password: "Prosím zadejte heslo",
  password_change_email_sent: "Na váš e-mail Kjuup byl odeslán e-mail. Potvrďte své nové heslo kliknutím na potvrzovací odkaz v e-mailu.",
  please_enter_username: "Prosím zadejte uživatelské jméno",
  username_same_as_before: "Uživatelské jméno nemůže být stejné jako dříve",
  profile_deleted_successfully: "Profil úspěšně smazán",
  hardware_requirements: "Požadavky na hardware",
  hardware_requirements_list: "• 4GB RAM<br/>• Rychlost CPU min. 2GHz<br/>• Windows 7 nebo vyšší / všechny verze macOS",
  submitting: "Odesílání...",
  signing_in: "Přihlašování...",
  please_enter_service_name: "Prosím zadejte název služby",
  something_went_wrong_error: "Aaaah! Něco se pokazilo...",
  something_went_wrong_try_again: "Omlouváme se, něco se tam pokazilo. Zkuste to znovu",
  position_label: "Pozice:",
  loading_room: "Načítání projektu...",
  navigating_to_room: "Navigace do projektu",
  loading_chat: "Načítání chatu...",
  translate: "Přeložit",
  show_original: "Zobrazit originál",
  saving: "Ukládání...",
  language_selection_info: "Výběr jazyka se používá pro všechna e-mailová potvrzení týkající se firmy.",
  // Navigation bar labels
  nav_call: "Zavolat",
  nav_home: "Domů",
  nav_messages: "Zprávy",
  nav_todo: "Úkoly",
  nav_rooms: "Projekty",
  nav_all_rooms: "Všechny projekty",
  pinned_rooms_max: "Můžete připnout až 10 projektů.",
  pinned_room_unpin: "Odepnout",
  pinned_rooms_drop: "Přetáhněte projekt sem pro rychlý výběr",
  nav_profile: "Profil",
  nav_company: "Firma",
  nav_company_documents: "Dokumenty",
  nav_logout: "Odhlásit se",
  // Create message dialog
  add_member_title: "Přidat člena",
  continue_btn: "Pokračovat",
  search_placeholder: "Hledat",
  no_members_found: "Nebyli nalezeni žádní členové",
  no_groups_found: "Nebyly nalezeny žádné skupiny",
  no_rooms_found: "Nebyly nalezeny žádné projekty",
  search_users_tab: "Uživatelé",
  search_documents_tab: "Dokumenty",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Žádné soubory",
  no_documents_available: "No documents",
  searching_users: "Vyhledávání uživatelů...",
  no_users_found: "Žádní uživatelé nenalezeni",
  search_emails_tab: "E-mail",
  searching_emails: "Vyhledávání e-mailů...",
  no_emails_found: "Žádné e-maily nenalezeny",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Skupina bez názvu",
  unnamed_room: "Projekt bez názvu",
  all_members: "Vše",
  room_label: "Projekt:",
  subject_label: "Předmět:",
  no_members: "Žádní členové",
  // Loading states for room creation
  creating_structure: "Vytváření vaší struktury",
  opening_chat: "Otevírání chatu",
  please_wait: "Prosím čekejte...",
  // ToDo page translations
  loading_todo: "Načítání ToDo...",
  task_updated: "Úkol aktualizován",
  error_updating_task: "Chyba při aktualizaci úkolu",
  task_deleted: "Úkol smazán",
  error_deleting_task: "Chyba při mazání úkolu",
  delete_task_confirm: "Jste si jisti, že chcete smazat tento úkol?",
  description_label: "Popis",
  description_placeholder: "Zadejte popis...",
  date_time_label: "Datum a čas",
  save_hint: "Ctrl+Enter pro uložení, Esc pro zrušení",
  edit_label: "Upravit",
  delete_label: "Smazat",
  todo_list_title: "Úkoly",
  tasks_count: "úkolů",
  search_placeholder_todo: "Hledat...",
  select_task_to_open_chat: "Vyberte úkol pro otevření chatu",
  today: "Dnes",
  yesterday: "Včera",
  time_suffix: "", // Empty for Czech (24h format doesn't need suffix)
  from_chat: "Zdrojový úkol",
  assigned_to: "Přiřazeno",
  assign_users: "Přiřadit uživatele",
  no_users_assigned: "Žádní přiřazení uživatelé",
  assign: "Přiřadit",
  assign_to: "Přiřadit...",
  navigate_to_chat: "Přejít na chat",
  navigate_to_email: "Přejít na e-mail",
  show_original_message: "Zobrazit zdroj",
  hide_original_message: "Skrýt zdroj",
  status_pending: "Čekající",
  status_in_progress: "Probíhá",
  status_completed: "Dokončeno",
  show: "Zobrazit",
  close: "Zavřít",
  // Log translation strings
  status_confirmed: "[Potvrzeno]",
  log_todo_created: "Úkol [vytvořen]",
  log_todo_confirmed: "Úkol [potvrzen]",
  log_todo_deleted: "Úkol [smazán]",
  log_todo_updated: "Úkol [aktualizován]",
  log_description_updated: "[Popis aktualizován]",
  log_deadline_updated: "[Termín aktualizován]",
  log_assigned_to: "[Přiřazeno k] {name}",
  log_unassigned_from: "[Odebráno od] {name}",
  log_assignment_added: "[Přiřazení přidáno]: {name}",
  log_assignment_removed: "[Přiřazení odebráno]: {name}",
  log_status_updated: "[Stav změněn z] {from} [na] {to}",
  log_status_changed: "[Stav změněn]",
  log_status_changed_to: "[Stav změněn na] {status}",
  log_changed_status_to: "[Změnil stav na]:",
  log_for_user: "[pro uživatele]:",
  log_user_updated_status: "[Uživatel aktualizoval svůj stav úkolu]",
  log_changed_date_to: "[Změnil datum na]:",
  log_changed_description_to: "[Změnil popis na]:",
  log_moved_to: "[Přesunuto na] {status}",
  todo_status_updated_from: "[z]",
  todo_status_updated_to: "[na]",
  filter_pending: "Čekající",
  filter_confirmed: "Potvrzeno",
  filter_assigned_to_me: "Moje úkoly",
  filter_assigned_by_me: "Delegováno",
  todo_project_label: "Projekt:",
  assigned_users: "Přiřazení uživatelé:",
  todo_chat_label: "Chat:",
  history: "Historie",
  todo_assigned_by: "Přiřazeno od:",
  todo_assigned_push: "Přiřazené ToDo:",
  todo_assigned_push_empty: "Bylo vám přiřazeno nové ToDo.",
  search_groups: "Skupiny",
  search_chat_groups: "Chat skupiny",
  search_project_room: "Projekt",
  search_messages_tab: "Zprávy",
  searching_groups: "Hledání skupin...",
  searching_rooms: "Hledání projektů...",
  no_groups_found: "Žádné skupiny nenalezeny",
  no_rooms_found: "Žádné projekty nenalezeny",
  create_poll: "Anketa",
  poll_question_label: "OTÁZKA",
  poll_question_placeholder: "Položte otázku",
  poll_options_label: "MOŽNOSTI",
  poll_option: "Možnost",
  poll_add_option: "Přidat možnost",
  poll_allow_multiple: "Povolit více odpovědí",
  poll_multiple_allowed: "Vyberte jednu nebo více možností",
  poll_select_option: "Vyberte jednu možnost",
  poll_view_votes: "Zobrazit hlasy",
  poll_vote_singular: "hlas",
  poll_vote_plural: "hlasů",
  poll_votes: "Výsledky hlasování",
  poll_no_votes_yet: "Zatím žádné hlasy",
  transcript_step_processing: "Transkripce probíhá...",
  ai_transcript_tab: "AI-Transkripce",
  ai_transcript_info: "K dispozici pouze pro hlasové zprávy vytvořené po 09.03.2026.",
  transcript_more: "...více",
  transcript_less: "...méně",
  ki_transcript_voice_message: "KI-Přepis hlasové zprávy",
  ki_image_analysis: "AI analýza obrázků",
  type_message: "Napište zprávu",
  email_tab_messages: "Zprávy",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-mailové účty",
  email_connect_gmail: "Připojit Gmail",
  email_connect_outlook: "Připojit Outlook",
  email_no_accounts: "Žádné e-mailové účty připojeny",
  email_no_accounts_hint: "Připojte e-mailový účet v nastavení profilu",
  email_no_messages: "Žádné e-maily",
  email_from: "Od",
  email_to: "Komu",
  email_subject: "Předmět",
  email_disconnect: "Odpojit",
  email_disconnect_confirm: "Opravdu chcete odpojit tento e-mailový účet? Všechny synchronizované e-maily budou odstraněny.",
  email_account_disconnected: "E-mailový účet byl úspěšně odpojen",
  email_account_disconnect_failed: "Nepodařilo se odpojit účet",
  email_connecting: "Připojování...",
  email_account_connected: "Účet úspěšně připojen",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Přejít do nastavení",
  email_date: "Datum",
  email_reply: "Odpovědět",
  email_forward: "Přeposlat",
  email_copy_text: "Kopírovat text",
  email_text_copied: "Zkopírováno!",
  email_text_copy_failed: "Text se nepodařilo zkopírovat.",
  email_delete: "Smazat",
  email_not_spam: "Není spam",
  email_not_spam_success: "E-mail přesunut do doručené pošty.",
  email_not_spam_failed: "Nepodařilo se přesunout do doručené pošty.",
  email_delete_confirm: "Opravdu chcete tento e-mail smazat?",
  email_delete_from_folder: "Opravdu chcete smazat ze složky {folder}?",
  email_delete_permanent_from_folder:
    "Opravdu chcete trvale smazat ze složky {folder}? Tuto akci nelze vrátit zpět.",
  email_save_draft_confirm: "Chcete uložit tento e-mail jako koncept?",
  email_save_draft: "Uložit koncept",
  email_discard: "Zahodit",
  email_back_to_compose: "Zpět k psaní",
  email_draft_saved: "Koncept uložen.",
  email_draft_save_failed: "Nepodařilo se uložit koncept.",
  email_loading: "Načítání e-mailů...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Vybrat",
  email_attachment_singular: "Příloha",
  email_attachment_plural: "Přílohy",
  email_back: "Zpět",
  email_download: "Stáhnout",
  email_close: "Zavřít",
  email_preview: "Náhled",
  email_preview_not_available: "Náhled není k dispozici",
  email_preview_failed: "Náhled není k dispozici",
  select_attachments: "Vybrat přílohy",
  email_loading_preview: "Načítání náhledu...",
  email_mark_unread_failed: "e-mail(y) nemohly být označeny jako nepřečtené.",
  email_delete_failed: "e-mail(y) nemohly být smazány.",
  filter_all: "Vše",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Přímé zprávy",
  my_notes: "My Space",
  filter_internal_groups: "Interní skupinové chaty",
  filter_external_groups: "Externí skupinové chaty",
  filter_group_chats: "Skupinové chaty",
  filter_groups_internal: "Interní",
  filter_groups_external: "Externí",
  filter_unread_only: "Pouze nepřečtené",
  room_daily_briefing_info: "Pokud je zapnuto, report pro tento projekt se vygeneruje každých 24 hodin v čase z osobních nastavení — ale pouze pokud v daném období probíhala aktivita.",
  email_select_all: "Vybrat vše",
  email_deselect_all: "Zrušit výběr",
  email_reply_all: "Odpovědět všem",
  email_reply_placeholder: "Napište odpověď...",
  email_forward_placeholder: "Přidejte zprávu...",
  email_edit_draft: "Upravit koncept",
  email_attach: "Připojit",
  email_attachment_from_original: "Z původní zprávy",
  email_remove: "Odebrat",
  email_drop_files: "Přetáhněte soubory k připojení",
  email_loading_attachments: "Načítání příloh...",
  email_archive: "Archivovat",
  mark_unread: "Označit jako nepřečtené",
  mark_read: "Označit jako přečtené",
  email_all_accounts: "Všechny účty",
  email_error: "Chyba",
  email_delete_email_failed: "Nepodařilo se smazat e-mail.",
  enter_url: "Zadejte URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Předplatit nyní',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MĚSÍC ZDARMA',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Dnes žádná platba. Údaje o kreditní kartě se nevyžadují, dokud nezačne placené předplatné.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Spravujte všechny e-mailové účty přímo v Kjuupu',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI píše odpovědi – vy jen potvrdíte',
  kjuup_io_feature_tasks: 'Úkoly a kalendář vždy automaticky aktuální',
  kjuup_io_choose_plan: 'Vyberte plán',
  kjuup_io_plan_monthly: 'Měsíčně',
  kjuup_io_plan_yearly: 'Ročně',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Zabezpečeno přes Stripe · zrušení kdykoli',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Platba přijata. Předplatné se aktivuje…',
  kjuup_io_toast_activating_soon: 'Platba přijata. Vaše předplatné bude brzy aktivováno.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Zbývá {count} h',
  kjuup_io_trial_left_hour: 'Zbývá 1 hodina',
  kjuup_io_trial_left_minutes: 'Zbývá {count} min',
  kjuup_io_trial_left_minute: 'Zbývá 1 minuta',
  kjuup_io_trial_left_seconds: 'Zbývá {count} s',
  kjuup_io_trial_left_second: 'Zbývá 1 sekunda',
  kjuup_io_trial_ending_now: 'Zkušební období končí…',
  kjuup_io_request_timeout: 'Časový limit připojení vypršel. Zkuste to znovu.',
  kjuup_io_info_days_free: '{days} dní zcela zdarma – předplatné začíná až po zkušební době.',
  kjuup_io_discount_total: 'Vaše sleva: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Osobní: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Zavřít',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Vaše bezplatné zkušební období skončilo',
  kjuup_io_trial_ended_body: 'Předplaťte si Kjuup.io, abyste mohli dál používat e-mail a další prémiové funkce.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Vaše bezplatné zkušební období začalo',
  kjuup_io_toast_trial_fail: 'Zkušební období se nepodařilo spustit',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / měsíc',
  kjuup_io_save_amount_year: 'Ušetříte {price} ročně',
  kjuup_io_billed_annually_amount: '{price} účtováno ročně',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Co získáte:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kreditní karta není potřeba – začněte hned bez platebních údajů.',
  kjuup_io_info_cancel_anytime: 'Zrušte kdykoli – žádný závazek, žádné riziko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Zúčtovací období',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Platební metoda uložena. Platba bude stržena na konci zkušebního období.',
  calendar_sync_info: 'Automaticky synchronizujte všechny Kjuup ToDo s vaším kalendářem.',
  calendar_no_accounts: 'Zatím není připojen žádný kalendář.',
  article_new_badge: 'NOVÉ',
  article_new_posts: '{0} nových příspěvků',
  documents: 'Dokumenty',
  add_documents: 'Přidat dokumenty',
  no_preview_available: 'Náhled není k dispozici',
  no_preview_hint: 'Tento typ souboru nelze zobrazit v náhledu, ale přesto bude odeslán.',
  max_documents_reached: 'Najednou můžete přiložit až 10 dokumentů.',
  open_file: 'Otevřít soubor',
  twofa_title: 'Dvoufaktorové ověření',
  twofa_method_totp: 'Ověřovací aplikace',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Zadej 6místný kód z ověřovací aplikace.',
  twofa_enter_sms: 'Zadej 6místný kód, který jsme poslali SMS.',
  twofa_enter_email: 'Zadej 6místný kód, který jsme poslali na e-mail.',
  twofa_resend: 'Poslat kód znovu',
  twofa_try_another: 'Zkusit jinou metodu',
  twofa_remember_device: 'Na tomto zařízení se 30 dní neptat',
  twofa_sent: 'Poslali jsme kód.',
  twofa_invalid_code: 'Tento kód je nesprávný. Zkus to znovu.',
  twofa_something_wrong: 'Něco se pokazilo. Zkus to znovu.',
  twofa_method_unavailable: 'Tato metoda není k dispozici.',
  twofa_on_desc: 'Dvoufaktorové ověření je zapnuté. Při každém přihlášení budeš potřebovat kód.',
  twofa_off_desc: 'Přidej po hesle druhý krok. Ověřovací aplikace jsou nejbezpečnější.',
  twofa_methods: 'Metody',
  twofa_on: 'Zapnuto',
  twofa_add: 'Přidat',
  twofa_default_method: 'Výchozí metoda',
  twofa_default: 'Výchozí',
  twofa_turn_off: 'Vypnout',
  twofa_disable_hint: 'Zadej heslo a aktuální kód pro vypnutí dvoufaktorového ověření.',
  twofa_disable_need: 'Zadej heslo a ověřovací kód.',
  twofa_code_placeholder: '6místný kód nebo záložní kód',
  twofa_send_code: 'Poslat kód',
  twofa_primary_updated: 'Výchozí metoda byla aktualizována.',
  twofa_disabled: 'Dvoufaktorové ověření je vypnuté.',
  twofa_enabled: 'Dvoufaktorové ověření je nyní zapnuté.',
  twofa_totp_help: 'Naskenuj tento QR kód v Google Authenticator, Authy nebo 1Password. Klíč můžeš zadat i ručně.',
  twofa_secret_copied: 'Klíč zkopírován',
  twofa_sms_help: 'Zadej číslo v mezinárodním formátu. Pošleme 6místný kód SMS.',
  twofa_email_help: 'Pošleme 6místný kód na e-mail tvého účtu.',
  twofa_backup_title: 'Záložní kódy',
  twofa_backup_help: 'Ulož si tyto jednorázové kódy na bezpečné místo. Každý kód lze použít jednou, když ztratíš telefon.',
  twofa_copy_codes: 'Kopírovat kódy',
  twofa_codes_copied: 'Záložní kódy zkopírovány',
  twofa_regenerate: 'Získat nové záložní kódy',
  twofa_regenerate_hint: 'Tím se nahradí nepoužité záložní kódy. Zadejte heslo a aktuální kód.',
  twofa_backup_remaining: 'Zbývá {n} nepoužitých záložních kódů',
  twofa_new_codes: 'Nové záložní kódy',
  twofa_sms_unavailable: 'SMS kódy zatím nejsou k dispozici.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Přiřazené úkoly Kjuup se zkopírují do projektu Kjuup ve vašem Todoist. Změny v Todoist se nekopírují zpět.",
  todoist_connect: "Připojit Todoist",
  todoist_connected: "Todoist připojen",
  todoist_connect_failed: "Připojení k Todoist se nezdařilo",
  todoist_disconnect: "Odpojit",
  todoist_disconnected: "Todoist odpojen",
  todoist_disconnect_confirm: "Odpojit Todoist? Úkoly, které už v Todoist jsou, zůstanou. Synchronizace se zastaví.",
  todoist_sync_now: "Synchronizovat",
  todoist_syncing: "Synchronizace…",
  todoist_sync_done: "Synchronizace dokončena",
  todoist_sync_failed: "Synchronizace se nezdařila",
  todoist_auth_error: "Znovu připojte Todoist, abyste mohli synchronizovat dál.",
  todoist_last_sync: "Poslední synchronizace",
  todoist_not_connected: "Todoist není připojen",
  todoist_auth_url_failed: "Nepodařilo se otevřít autorizační stránku Todoist.",
  recommend_text: "Přidej se ke Kjuup, zůstaň ve spojení a měj svou komunikaci v pořádku. Spoj své kanály, drž zprávy ve správných projektech a začínej každé ráno souhrnem a svými úkoly – vše synchronizované s aplikacemi, které už používáš. Začni zdarma:",
  pro_auth_signin_title: 'Vítejte zpět',
  pro_auth_signin_sub: 'Přihlaste se pracovním e-mailem.',
  pro_auth_email_or_username: 'E-mail nebo uživatelské jméno',
  pro_auth_email_placeholder: 'jmeno@firma.cz',
  pro_auth_forgot_password: 'Zapomněli jste heslo?',
  pro_auth_create_account: 'Vytvořit účet',
  pro_auth_show_password: 'Zobrazit heslo',
  pro_auth_hide_password: 'Skrýt heslo',
  pro_auth_register_sub: 'Pošleme vám odkaz pro potvrzení e-mailu.',
  pro_auth_register_plus_sub: 'Zvolte uživatelské jméno a heslo. Poté nastavíte svůj bezpečnostní PIN.',
  pro_auth_check_credentials: 'Zkontrolujte svůj e-mail a heslo',
  pro_news_export_pdf: 'Exportovat jako PDF',
  pro_news_pdf_failed: 'PDF se nepodařilo vytvořit.',
  pro_news_pdf_attachments: 'Přílohy',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Zadejte svůj e-mail a my vám pošleme odkaz pro obnovení hesla.',
  pro_auth_send_link: 'Poslat odkaz pro obnovení',
  pro_auth_plus_reset: 'Obnovit pomocí PIN',
  pro_auth_show_pin: 'Zobrazit PIN',
  pro_auth_hide_pin: 'Skrýt PIN',
  v2_auth_plus_only: 'Pouze Kjuup+',
  room_action_media: "Soubory",
  room_tab_overview: "Přehled",
  room_tab_history: "Historie",
  chat_info_media: "Soubory",
  messages: "zprávy",
  pro_todo_project_required: "Vyberte prosím projekt",
  pro_todo_choose_project: "Pro který projekt je tento úkol?",
  cockpit_report_delete_confirm: "Smazat tento denní report?",
  cockpit_report_deleted: "Denní report smazán",
  cockpit_tab_company: "Firma",
  cockpit_bookmarked_priorities: "Označené úkoly",
  cockpit_load_error: "Cockpit se nepodařilo načíst.",
  cockpit_retry: "Zkusit znovu",
  cockpit_yesterday: "Včera",
  cockpit_greeting_morning: "Dobré ráno",
  cockpit_greeting_day: "Dobrý den",
  cockpit_greeting_evening: "Dobrý večer",
  cockpit_assistant_q_open: "Co je dnes otevřené?",
  cockpit_assistant_q_summarize: "Shrň chat {{room}}",
  cockpit_assistant_q_overdue: "Které úkoly jsou po termínu?",
  cockpit_assistant_new: "{{n}} nových",
  cockpit_assistant_important: "{{n}} důležitých",
  cockpit_assistant_title: "Asistent Kjuup",
  cockpit_assistant_hint: "Klepněte a zeptejte se",
  room_overview_priority_no_detail: "Report neuvádí k této prioritě další podrobnosti.",
  room_overview_priority_from: "Zdroj: {{name}}",
  room_overview_priority_open_task: "Otevřít úkol",
  cockpit_priority_position: "{{index}} z {{total}} priorit",
  room_overview_today_title: "Dnes důležité",
  room_overview_all_tasks: "Vše",
  room_overview_tasks_empty: "Žádné otevřené termíny ani úkoly",
  room_overview_appointments_empty: "Žádné nadcházející schůzky",
  room_overview_no_priorities: "V posledním reportu nejsou žádné otevřené priority.",
  cockpit_report_top5: "Top 5 priorit",
  cockpit_report_todo_created: "Úkol vytvořen",
  cockpit_report_source_missing: "Zdrojová zpráva nebyla nalezena.",
  delete_bookmarked_priority_confirm: "Opravdu chcete smazat tento označený úkol?",
  cockpit_report_create_todo: "Vytvořit úkol",
  cockpit_priorities_deleting: "Mazání …",
  cockpit_priorities_select: "Smazat více",
  cockpit_report_none: "Žádné záznamy.",
  cockpit_priorities_delete_confirm: "Opravdu chcete smazat označené úkoly ({count})?",
  cockpit_priorities_delete_failed: "Nepodařilo se smazat úkoly: {count}",
  cockpit_priorities_deleted: "Smazáno úkolů: {count}",
  cockpit_priorities_selected: "Vybráno: {count}",
  cockpit_channel_connected: "Připojeno",
  cockpit_channel_not_connected: "Nepřipojeno",
  cockpit_channel_connect: "Připojit",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Aktivní",
  cockpit_channel_hidden: "Skryto",
  cockpit_channel_enable: "Zapnout",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Zkontrolovat připojení",
  cockpit_channel_fix: "Zkontrolovat",
  cockpit_channel_forward: "Adresa pro přeposílání",
  cockpit_channel_not_set_up: "Nenastaveno",
  cockpit_channel_set_up: "Nastavit",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Připojení přerušeno",
  cockpit_channel_importing: "Probíhá import",
  cockpit_channel_removing: "Odpojování",
  cockpit_channel_reconnect: "Připojit znovu",
  cockpit_channels_title: "Kanály",
  cockpit_company_role_super_admin: "Správce firmy",
  cockpit_company_role_dept_admin: "Správce oddělení",
  cockpit_company_role_member: "Zaměstnanec",
  cockpit_company_none: "Nebyla nalezena žádná firma Kjuup+",
  cockpit_company_eyebrow: "Firma",
  cockpit_company_inactive: "neaktivní",
  cockpit_company_settings: "Nastavení firmy",
  cockpit_company_employees: "Zaměstnanci",
  cockpit_company_internal_rooms: "Interní projekty",
  cockpit_report_all_projects: "Všechny projekty",
  cockpit_report_progress_emails: "Analyzují se e-maily",
  cockpit_report_progress_chats: "Analyzují se zprávy chatu",
  cockpit_report_progress_documents: "Analyzují se přílohy a dokumenty",
  cockpit_report_progress_tasks: "Analyzují se úkoly",
  cockpit_report_progress_summarizing: "Analyzuje se obsah",
  cockpit_report_progress_reading: "Přebírá se již analyzovaný obsah",
  cockpit_report_progress_collecting: "Shromažďují se e-maily, chaty a úkoly z vašich projektů",
  cockpit_report_progress_priorities: "Sestavují se priority, termíny a rozhodnutí",
  cockpit_report_progress_queued: "Report se připravuje",
  cockpit_report_creating_title: "Váš denní report se vytváří",
  cockpit_report_progress_count_one: "Analyzována 1 položka",
  cockpit_report_progress_count_many: "Analyzováno položek: {{count}}",
  cockpit_report_progress_hint: "Obvykle to trvá jednu až dvě minuty – mezitím můžete cockpit dále používat.",
  cockpit_report_time_hint: "Denní report se vytváří každý den v {{hour}}:00 pro pět nejaktivnějších projektů.",
  room_overview_priorities_title: "Aktuální stav a priority",
  room_overview_as_of: "Stav k: {{time}}",
  cockpit_report_delete: "Smazat denní report",
  email_tag_daily_briefing: "Denní report",
  cockpit_report_unread: "Nové",
  cockpit_report_clear_project: "Zobrazit všechny projekty",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Všechny projekty",
  cockpit_report_recreate: "Vytvořit denní report znovu",
  cockpit_report_hide_previous: "Skrýt předchozí denní reporty",
  cockpit_report_show_previous: "Zobrazit předchozí denní reporty",
  cockpit_report_room_empty: "Pro tento projekt zatím není žádný denní report",
  cockpit_report_empty: "Zatím žádný denní report",
  cockpit_report_room_empty_hint: "Vytvořte denní report pouze pro tento projekt.",
  cockpit_report_needs_mailbox: "Připojte e-mailový účet, aby Kjuup mohl vytvářet denní report s automatickými úkoly.",
  cockpit_report_create: "Vytvořit denní report",
  cockpit_email_connect: "Připojit e-mail",
  cockpit_email_none_title: "Zatím není připojen žádný e-mailový účet",
  cockpit_email_none_reports: "Připojte svou schránku, aby Kjuup přiřazoval příchozí e-maily k vašim projektům a vytvářel z nich denní reporty s úkoly.",
  cockpit_email_none_client: "Připojte Gmail, Outlook nebo IMAP a čtěte, přiřazujte a odpovídejte na e-maily přímo v Kjuup.io.",
  cockpit_email_reports_title: "Dosavadní e-mailový klient",
  cockpit_email_reports_text: "Žádná schránka v Kjuup.io · projekty s denním reportem v {{hour}}:00: {{rooms}} · příchozí e-maily se přiřazují k vašim projektům.",
  cockpit_email_reports_rooms: "Spravovat projekty",
  cockpit_email_settings: "Nastavení e-mailu",
  cockpit_email_error_title: "Zkontrolovat připojení",
  cockpit_email_client_title: "Příjem nastaven",
  cockpit_email_accounts_n: "Připojené účty: {{n}}",
  cockpit_email_last_sync: "poslední stažení {{when}}",
  cockpit_email_report_at: "Denní report v {{hour}}:00",
  cockpit_email_open_inbox: "Otevřít schránku",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Připojené e-mailové adresy",
  email_folder_sent: "Odeslané položky",
  email_no_subject: "(Bez předmětu)",
  cockpit_email_detail_loading: "Načítání e-mailu …",
  cockpit_email_detail_failed: "E-mail se nepodařilo načíst.",
  cockpit_email_detail_empty: "Tento e-mail neobsahuje text.",
  cockpit_personal_settings: "Osobní nastavení",
  cockpit_companies: "Firmy",
  cockpit_title: "Cockpit",
  cockpit_back: "Zpět na přehled",
  cockpit_day_overview: "Váš den v kostce",
  email_saved_to_project: "E-mail uložen v projektu",
  email_classify_need_project: "Zadejte název projektu",
  cockpit_email_deleted: "E-mail smazán",
  cockpit_email_sent_empty: "Zatím žádné odeslané e-maily.",
  cockpit_email_incoming_empty: "Zatím žádné příchozí e-maily.",
  cockpit_email_incoming_title: "E-maily",
  cockpit_email_incoming_sub: "Přiřaďte příchozí a odeslané e-maily ke svým projektům. Přiřazení zde můžete upravit.",
  cockpit_email_incoming_unassigned_n: "Nepřiřazeno: {{n}}",
  cockpit_email_folder_inbox: "Doručené",
  cockpit_email_folder_sent: "Odeslané",
  cockpit_email_open: "Otevřít e-mail",
  cockpit_email_incoming_suggested: "Návrh: {{room}}",
  cockpit_email_incoming_apply: "Použít",
  cockpit_email_incoming_adjust: "Upravit přiřazení",
  cockpit_email_incoming_saving: "Ukládání …",
  cockpit_email_incoming_unassigned: "Nepřiřazeno",
  cockpit_email_incoming_show_less: "Zobrazit méně",
  cockpit_email_incoming_show_all: "Zobrazit vše ({{n}})",
  cockpit_io_settings: "Nastavení Kjuup.io",
  cockpit_io_settings_sub: "Tarif a licence, přiřazení zaměstnanců a také fakturace a faktury.",
  products_coming_soon: "Již brzy",
  cockpit_upsell_io_title: "Vaše kancelář, která myslí s vámi",
  cockpit_upsell_io_text: "Propojte své e-mailové účty s Kjuup. E-maily, přílohy a zprávy se automaticky ukládají do odpovídajícího projektu a volitelně je lze ukládat na váš server. Každý den dostanete souhrn všech projektů s nejdůležitějšími body ze všech obsahů a vaše úkoly se synchronizují s kalendářem nebo aplikací pro úkoly.",
  cockpit_upsell_io_soon_title: "Zatím nelze objednat",
  cockpit_upsell_io_soon_text: "Kjuup.io brzy startuje. Vyžádejte si informace – ozveme se vám, jakmile si budete moci Kjuup.io objednat.",
  cockpit_upsell_io_planned_price: "Plánovaná cena",
  cockpit_upsell_io_cta_request: "Vyžádat informace",
  kjuup_plus_abo_per_year: "/ rok",
  kjuup_plus_abo_per_month: "/ měsíc",
  kjuup_plus_abo_status_active: "Aktivní",
  kjuup_plus_abo_status_requested: "Žádost o zrušení",
  kjuup_plus_abo_status_past_due: "Platba čeká",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Předplatné",
  kjuup_plus_abo_title: "Balíček Kjuup+",
  kjuup_plus_abo_seats_free_one: "Zbývá 1 místo",
  kjuup_plus_abo_billing: "Způsob platby",
  kjuup_plus_abo_yearly: "Ročně",
  kjuup_plus_abo_monthly: "Měsíčně",
  kjuup_plus_abo_amount: "Částka",
  kjuup_plus_abo_ends: "Končí dne",
  kjuup_plus_abo_renews: "Další prodloužení",
  kjuup_plus_abo_next_invoice: "Další faktura",
  kjuup_plus_abo_intro: "Úvodní cena",
  kjuup_plus_abo_pending_tier: "Od dalšího prodloužení",
  kjuup_plus_abo_manual: "Kjuup+ je pro vaši firmu aktivní na základě individuální dohody.",
  kjuup_plus_abo_invoices: "Faktury",
  kjuup_plus_abo_invoice_paid: "Zaplaceno",
  kjuup_plus_abo_invoice_view: "Zobrazit",
  kjuup_plus_abo_invoices_less: "Zobrazit méně",
  kjuup_plus_abo_member_hint: "Fakturaci a zrušení spravují správci firmy.",
  kjuup_plus_abo_withdraw: "Stáhnout žádost",
  kjuup_plus_abo_cancel_note: "Důvod (volitelné)",
  kjuup_plus_abo_cancel_send: "Požádat o zrušení",
  kjuup_plus_abo_cancel: "Zrušit předplatné",
  cockpit_upsell_plus_f1: "Správa komunikačních aktivit všech zaměstnanců",
  cockpit_upsell_plus_f2: "Informování vybraných skupin uživatelů ve firmě",
  cockpit_upsell_plus_f3: "Ukládání interních skupinových chatů",
  cockpit_upsell_plus_when_yearly: "při roční platbě",
  cockpit_upsell_plus_size_small: "1–50 zaměstnanců",
  cockpit_upsell_plus_size_large: "51–200 zaměstnanců",
  cockpit_upsell_plus_title: "Kjuup+ pro firmy",
  cockpit_upsell_plus_text: "Spravujte zaměstnance, práva k psaní a firemní komunikaci na jednom místě. Interní kanály zůstávají u vašich zaměstnanců, externí kanály vás spojují s projektovými partnery a vybrané skupiny můžete informovat cíleně. Navíc ke Kjuup+ můžete objednat přístupy Kjuup.io pro skupiny zaměstnanců. Kjuup+ a Kjuup.io lze kombinovat.",
  cockpit_upsell_plus_size: "Velikost firmy",
  cockpit_upsell_plus_billing: "Způsob platby",
  cockpit_upsell_plus_per_company: "/ firma · měsíc bez DPH",
  cockpit_upsell_plus_onboarding: "Náklady na zavedení závisí na velikosti firmy",
  cockpit_upsell_plus_larger: "Ceny pro větší firmy na vyžádání",
  cockpit_upsell_plus_cta: "Nezávazně poptat",
  cockpit_kpi_deadlines_tasks: "Termíny a úkoly",
  cockpit_kpi_appointments: "Schůzky",
  cockpit_room_admin: "Správa projektů a chatů",
  cockpit_room_admin_sub: "Všechny projekty firmy s členy, médii a chaty.",
  pro_todo_not_found: "Tento úkol již není k dispozici.",
  cockpit_chip_overdue: "Po termínu",
  cockpit_chip_today: "Dnes",
  cockpit_calendar_week: "{{week}}. týden",
  cockpit_prev_week: "Předchozí týden",
  cockpit_next_week: "Další týden",
  cockpit_chip_requested: "Vyžádáno",
  cockpit_todo_due: "Termín {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "od {{name}}",
  cockpit_todo_since: "od {{when}}",
  cockpit_todo_no_date: "Bez data",
  cockpit_todo_mark_done: "Označit jako hotové",
  cockpit_my_tasks_title: "Moje úkoly",
  cockpit_today_tasks_group: "Úkoly na dnes",
  cockpit_assign_none: "Nikdo není přiřazen",
  no_project_found: "Projekt nebyl nalezen",
  cockpit_row_more_actions: "Další akce",
  needs_date: "Přiřadit termín",
  cockpit_assign_proposal: "Rozpoznáno {{name}} – přiřadit?",
  cockpit_assign_proposal_confirm: "Přiřadit",
  cockpit_assign_proposal_dismiss: "Ignorovat",
  cockpit_priority_date: "Datum",
  todo_calendar_add: "Přidat do kalendáře",
  todo_calendar_remove: "Odebrat z kalendáře",
  cockpit_todo_change_project: "Změnit projekt",
  cockpit_todo_set_date: "Nastavit datum",
  pro_todo_done_confirm: "Opravdu chcete tento úkol označit jako hotový?",
  cockpit_task_delete_failed: "Úkol se nepodařilo smazat.",
  cockpit_setup_title: "Dokončit nastavení",
  cockpit_setup_text: "Rozhodněte, zda chcete používat chaty a zda má Kjuup.io fungovat jako e-mailový klient, nebo pouze s projekty a denními reporty.",
  cockpit_setup_cta: "Nastavit nyní",
  cockpit_group_tasks: "Termíny a úkoly",
  cockpit_group_appointments: "Schůzky",
  cockpit_report_no_activity: "V tomto projektu nebyly za posledních 24 hodin žádné nové zprávy ani e-maily.",
  cockpit_report_room_unavailable: "Tento projekt není k dispozici.",
  cockpit_report_create_failed: "Denní report se nepodařilo vytvořit.",
  cockpit_report_created: "Denní report vytvořen",
  addon_enable_confirm: "Zapnout doplněk?",
  addon_enable: "Zapnout",
  addon_enabled: "Doplněk zapnut",
  nav_email: "E-mail",
  nav_my_cockpit: "Můj cockpit",
  nav_news: "Novinky",
  nav_recommend: "Doporučit",
  pro_todo_status_done: "Hotovo",
  pro_todo_status_open: "Otevřeno",
  v2_todo_remove: "Odebrat",
  pro_todo_search_people: "Hledat osoby",
  pro_todo_clear: "Vymazat",
  pro_todo_assigned: "(přiřazeno)",
  pro_todo_no_people: "Nebyly nalezeny žádné osoby",
  pro_todo_search_rooms: "Hledat projekty",
  pro_todo_no_rooms_match: "Žádné projekty pro „{{q}}“",
  pro_todo_no_rooms: "Nebyly nalezeny žádné projekty",
  pro_todo_activity: "Aktivita",
  pro_todo_show_less: "Zobrazit méně",
  pro_todo_show_all: "Zobrazit vše ({{n}})",
  pro_todo_due: "Termín",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Vybrat projekt",
  pro_todo_status: "Stav",
  pro_todo_more: "Více",
  pro_todo_edit_title: "Upravit úkol",
  pro_todo_description: "Popis",
  pro_todo_created_by: "Vytvořil(a)",
  pro_todo_chat: "Chat",
  navigate_to_source: "Přejít ke zdroji",
  todo_calendar_connect_title: "Není připojen žádný kalendář",
  todo_calendar_connect_body_web: "Připojte kalendář v nastavení synchronizace kalendáře, abyste do něj mohli přidávat úkoly.",
  todo_calendar_connect: "Připojit",
  todo_calendar_removed: "Odebráno z vašeho kalendáře",
  todo_calendar_added_later: "Přidáno. Kalendář nebyl dostupný, Kjuup to zkusí znovu později.",
  todo_calendar_added: "Přidáno do vašeho kalendáře",
  todo_calendar_no_date: "Do kalendáře lze přidat pouze úkol s datem.",
  todo_calendar_failed: "Kalendář se nepodařilo aktualizovat. Zkuste to prosím znovu.",
  todo_calendar_date_title: "Zatím bez data",
  todo_calendar_date_save: "Nastavit datum a přidat",
  todo_calendar_date_body_web: "Tento označený úkol zatím nemá datum. Nastavte ho, abyste jej mohli přidat do kalendáře.",
  kjuup_io_setup_saved: "Nastavení uloženo",
  kjuup_io_setup_step: "Krok",
  kjuup_io_setup_chats_title: "Chcete používat chaty?",
  kjuup_io_setup_email_title: "Kde chcete číst své e-maily?",
  kjuup_io_setup_chats_sub: "Chaty s kolegy a projektovými partnery jsou volitelné. V cockpitu je můžete kdykoli zobrazit nebo skrýt.",
  kjuup_io_setup_email_sub: "Zde pouze určujete, zda používáte e-mailového klienta v Kjuup, nebo dále pracujete se svým dosavadním programem, například Outlookem či jiným. Později to můžete změnit.",
  kjuup_io_setup_chats_yes: "Ano, zobrazit chaty",
  kjuup_io_setup_chats_yes_text: "Zprávy obsahují chaty a e-maily. Projekty mají skupinové chaty pro všechny zúčastněné.",
  kjuup_io_setup_chats_no: "Ne, pracovat bez chatů",
  kjuup_io_setup_chats_no_text: "Chaty jsou skryty. Z „Zpráv“ se stane „E-mail“; projekty, úkoly a denní reporty zůstávají.",
  kjuup_io_setup_email_client: "E-mailový klient v Kjuup",
  kjuup_io_setup_email_client_text: "Čtěte e-maily a odpovídejte na ně přímo v Kjuup.",
  kjuup_io_setup_email_reports: "Dosavadní e-mailový klient",
  kjuup_io_setup_email_reports_text: "Nadále čtěte e-maily a odpovídejte na ně ve svém současném programu, například v Outlooku či jiném.",
  kjuup_io_setup_skip: "Později",
  next: "Další",
  kjuup_io_setup_finish: "Dokončit nastavení",
  today_label: "dnes",
  tomorrow_label: "zítra",
  cockpit_todo_overdue: "po termínu",
  cockpit_report_management_fazit: "Shrnutí pro vedení",
  cockpit_todo_appointment: "Schůzka",
  cockpit_todo_deadline: "Termín",
  cockpit_todo_deadline_define: "Určit termín",
  pro_todo_status_acknowledged: "Potvrzeno",
  pro_todo_responsible: "Odpovědná osoba",
  pro_todo_notice_confirmed: "Potvrzeno v chatu",
  pro_todo_notice_sent_at: "Zpráva odeslána",
  pro_todo_notice_again: "Odeslat zprávu znovu",
  pro_todo_notice_send: "Informovat zprávou Kjuup",
  pro_todo_add_assignee: "Přidat",
  pro_todo_edit: "Upravit",
  pro_todo_change_room: "Změnit projekt",
  pro_todo_due_on: "Termín do",
  pro_todo_edit_due: "Upravit termín",
  pro_todo_no_date: "Bez data",
  pro_todo_edit_description: "Upravit popis",
  pro_todo_no_description: "Zatím bez popisu",
  pro_todo_title_label: "Název",
  pro_todo_title_placeholder: "Zadejte název...",
  pro_todo_task: "Úkol",
  pro_todo_what: "Co je potřeba udělat?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Zdroje",
  previous: "Předchozí",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (až {max} zaměstnanců)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (až {max} zaměstnanců)",
  kjuup_plus_abo_status_ends: "Končí {date}",
  kjuup_plus_abo_seats_over: "Více než {max} zaměstnanců – Kjuup vás kontaktuje s individuální nabídkou.",
  kjuup_plus_abo_seats_next: "Pokud přibudou další zaměstnanci, balíček se automaticky přepne na {next} (poměrně vyúčtováno).",
  kjuup_plus_abo_seats_used: "Obsazeno {used} z {total} míst",
  kjuup_plus_abo_seats_free: "Volná místa: {count}",
  kjuup_plus_abo_intro_until: "do {date}",
  kjuup_plus_abo_invoice_open: "Neuhrazeno · splatnost {date}",
  kjuup_plus_abo_invoices_all: "Zobrazit vše ({count})",
  kjuup_plus_abo_requested_hint: "O zrušení požádáno {date}. Kjuup ho potvrdí ke konci období ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup posoudí vaši žádost a potvrdí zrušení ke konci období ({end}). Do té doby zůstává Kjuup+ aktivní.",
  kjuup_plus_abo_withdrawn: "Žádost o zrušení stažena",
  kjuup_plus_abo_requested: "Zrušení požadováno",
  cockpit_upsell_plus_intro_hint: "první {months} měsíce, poté {price}",
  cockpit_upsell_plus_badge: "ZAVÁDĚCÍ CENA NA {months} MĚSÍCE",
  calendar_syncing: "Aktualizace z kalendáře…",
  calendar_sync_up_to_date: "Kalendář je aktuální",
  calendar_sync_failed: "Synchronizace se nezdařila",
  delete_multiple_tasks_confirm: "Opravdu chcete smazat {count} ToDo?",
  todos_deleted_count: "Smazáno {count} ToDo",
  todos_deleted_partial: "Smazáno {ok} ToDo, {fail} se nezdařilo",
  todo_unknown: "Neznámý",
  todo_created_from_message: "Úkol vytvořen z této zprávy",
  kjuup_io_todo_calendar_trial_ended_note: "Synchronizace kalendáře · Předplatit",
  kjuup_io_todo_calendar_nudge: "Synchronizovat toto ToDo do kalendáře?",
  kjuup_io_todo_calendar_nudge_cta: "Aktivovat Kjuup.io",
  todo_confirmed: "ToDo potvrzeno",
  pro_todo_bulk_delete_title: "Smazat úkoly ({{n}})?",
  pro_todo_previous_none_own: "Úkoly po termínu vám přidělili jiní a smazat je mohou jen oni.",
  pro_todo_previous_none: "Žádné úkoly po termínu",
  pro_todo_previous_title: "Smazat úkoly po termínu ({{n}})?",
  pro_todo_previous_text: "Všechny vaše otevřené úkoly z předchozích dnů budou smazány.",
  pro_todo_previous_skipped: "Úkoly přidělené jinými zůstanou: {{n}}.",
  unassign_task_confirm: "Chcete zrušit své přiřazení k tomuto úkolu?",
  unassign_label: "Zrušit",
  pro_todo_delete_title: "Smazat úkol",
  pro_todo_today: "Dnes",
  pro_todo_yesterday: "Včera",
  pro_todo_since_yesterday: "Od včerejška",
  pro_todo_mark_open: "Označit jako otevřený",
  verify_completion: "Ověřit",
  new_label: "Nové",
  bookmarked_no_mylist: "Úkoly v záložkách nelze přidat do Mého seznamu",
  delete_only_own: "Můžete mazat jen úkoly, které jste vytvořili",
  todo_clear_all: "Vymazat vše",
  pro_todo_of_completed: "Dokončeno {{done}} z {{total}}",
  pro_todo_pick_date: "Vyberte datum",
  pro_todo_show_day: "Zobrazit den",
  todo_adjust_list: "Upravit seznam",
  pro_todo_section_upcoming: "Nadcházející",
  pro_todo_section_done: "Hotovo",
  pro_todo_room_empty_today: "Dnes v tomto projektu nejsou žádné úkoly",
  pro_todo_room_empty_day: "V tento den v tomto projektu nejsou žádné úkoly",
  pro_todo_delete_previous: "Smazat vše",
  todo_my_list_empty: "Váš den je prázdný",
  todo_my_list_empty_hint: "Klikněte na „Upravit seznam“ a přidejte úkoly",
  pro_todo_empty_title: "Nic tu není",
  pro_todo_empty_hint: "Tomuto zobrazení neodpovídají žádné úkoly.",
  pro_todo_selected: "Vybráno: {{n}}",
  delete_selected_count: "Smazat ({count})",
  pro_todo_adjust_done: "Hotovo",
  pro_todo_deleting: "Mazání...",
  pro_todo_reopen: "Znovu otevřít úkol",
  pro_todo_step_done: "Hotovo",
  move_back_in_progress: "Vrátit do stavu Probíhá",
  pro_todo_mark_not_started: "Označit jako nezahájené",
  back_into_in_progress: "Zpět do stavu Probíhá",
  pro_todo_mark_in_progress: "Označit jako probíhající",
  unassign_todo: "Zrušit přiřazení ToDo",
  pro_todo_open_room: "Otevřít projekt",
  pro_todo_new_task: "Nový úkol",
  select_user_back_to_in_progress: "Vyberte uživatele, kterého chcete vrátit do stavu Probíhá",
  cockpit_email_accounts_n_many: "Připojené účty: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kontakty Kjuup",
  combined_tab_teams: "Kontakty Teams",
  combined_bridge_failed: "Kopii v Teams se nepodařilo vytvořit.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kontakty Kjuup a Teams: vytvoří se nová skupina, která se zobrazí i v Microsoft Teams.",
  teams_new_chat_title: "Nový chat Teams",
  teams_new_chat_topic: "Název skupiny (nepovinné)",
  teams_new_chat_start: "Zahájit chat",
  teams_new_chat_creating: "Vytváření chatu…",
  teams_new_chat_forbidden: "Microsoft Teams tento chat nepovoluje (např. osoba mimo vaši organizaci nebo pravidlo vašeho IT).",
  teams_new_chat_too_many: "Příliš mnoho osob pro jeden chat.",
  teams_new_chat_type_hint: "Zadejte jméno pro hledání ve vaší organizaci.",
  teams_new_chat_directory_forbidden: "Vaše organizace nepovoluje hledání v adresáři. Zobrazují se jen osoby z vašich chatů Teams.",
  teams_new_chat_account: "Účet",
};
